import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=cc765b14&scoped=true&"
import script from "./electric.vue?vue&type=script&lang=js&"
export * from "./electric.vue?vue&type=script&lang=js&"
import style0 from "./electric.vue?vue&type=style&index=0&id=cc765b14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc765b14",
  null
  
)

export default component.exports